import { useEffect, useRef } from 'react'
import type { Fleet } from '../domain/schemas'
import { visibleInterval } from '../infra/visibleInterval'
import { useApi } from './api-context'
import { useLoad, type Loaded } from './useLoad'

/** There is no admin event stream, so the fleet is polled. Hidden tabs don't poll; coming back refreshes at once. */
export const FLEET_POLL_MS = 15_000

export interface FleetLoad {
  fleet: Fleet
  /** Our clock when it arrived, to tick the server's clock forward between polls (domain/fleet.ts, serverNow). */
  receivedAt: number
}

/** Every live box's agent health, or one founder's with `founderId`. Keeps the last answer while a poll fails. */
export function useFleet(founderId?: string): Loaded<FleetLoad> {
  const { api } = useApi()
  const load = useLoad(async () => ({ fleet: await api.fleet(founderId), receivedAt: Date.now() }), [api, founderId])
  const reload = useRef(load.reload)
  reload.current = load.reload
  useEffect(() => visibleInterval(() => reload.current(), FLEET_POLL_MS), [])
  return load
}
